import Axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { SerializedError } from "@reduxjs/toolkit";
import "./loading.scss";
import {
  getAccessAdminToken,
  getAccessToken,
  getWorkspaceCode,
  removeAccessAdminToken,
  removeAdminInfoFromLocalStorage,
} from "./auth";
import { stores } from "../../App";
import { startProgress, stopProgress } from "../../redux/store/progress";
// import { startProgress, stopProgress } from "src/store/progress";
const axiosAdmin = Axios.create({
  withCredentials: true,
  headers: {
    locale: "kr-KR",
    "Accept-Language": window.navigator.language.includes("ko")
      ? "ko"
      : ["jp", "ja"].includes(window.navigator.language)
      ? "jp"
      : "en",
  },
});

let alramCount = 0;

axiosAdmin.interceptors.request.use(
  function (config: InternalAxiosRequestConfig) {
    stores.dispatch(startProgress());

    //(Loading);
    // 요청을 보내기 전에 수행할 일
    // ...
    const adminToken = getAccessAdminToken() as string | "";
    const dsdCode = getWorkspaceCode() as string | "";
    const userToken = getAccessToken() as string | "";

    if (userToken && window.eco.serviceType === "OCI") {
      config.headers.set("X-FASOO-API-TOKEN", userToken);
      config.headers.set("X-FASOO-DSDCODE", dsdCode ?? "MTECOCOMMON00001");
    } else if (adminToken) {
      config.headers.set("X-FASOO-API-TOKEN", adminToken);
    }

    return config;
  },
  function (error) {
    // 오류 요청을 보내기전 수행할 일
    // ...
    return Promise.reject(error);
  }
);

// 응답 인터셉터 추가
axiosAdmin.interceptors.response.use(
  (response) => {
    stores.dispatch(stopProgress());
    return response;
  },
  (error: AxiosError) => {
    stores.dispatch(stopProgress());
    // 오류 응답을 처리
    // ...
    let se: SerializedError;

    if (error.response) {
      const errorData = error.response.data as any;
      // if (error.response.status === 401) {
      //   removeToken();
      //   removeUser();
      //   window.location.reload();
      //   return;
      // }
      if (errorData.errorCode) {
        switch (errorData.errorCode) {
          case "INVALID_SESSION":
            getAccessAdminToken();
            removeAdminInfoFromLocalStorage();
            window.location.reload();
            return;
          // 저장된 세션 삭제 후 로그인 페이지로 이동
          case "ZOOM_ACCOUNT_NOT_USE_ECO":
            return;
          case "NOT_FOUND_USER":
            return;
          case "NOT_FOUND_DATA":
            break;
          case "BAD_REQUEST":
            break;
          case "INTERNAL_SERVER_ERROR":
          case "INVALID_USER_ID_PWD":
          default:
            break;
        }
      }

      se = {
        name: errorData.errorCode,
        message: errorData.errorMessage,
      };

      return Promise.reject(se);
    }

    se = {
      name: "INTERNAL_SERVER_ERROR",
      message: "INTERNAL_SERVER_ERROR",
    };
    return Promise.reject(se);
  }
);
export default axiosAdmin;
